const baseVueRouterPath = "";

const mapRoutesWithBasePath = (basePath = "", routes, { prefix }) => routes.map((route) => ({
  ...route,
  path: `${basePath}${route.path}`,
  name: `${prefix}${route.name}`,
}));

const mapAutomationsRoutes = (routes) => mapRoutesWithBasePath(`${baseVueRouterPath}/dashboard/automations`, routes, {
  prefix: "dashboard.automations.",
});

const mapDashboardRoutes = (routes) => mapRoutesWithBasePath(`${baseVueRouterPath}/dashboard`,
  routes, {
    prefix: "dashboard.",
  });

const mapInsuranceRoutes = (routes) => mapRoutesWithBasePath(
  `${baseVueRouterPath}/customer/:customer/insurance`,
  routes,
  { prefix: "insurance." },
);

const mapTaskRoutes = (routes) => mapRoutesWithBasePath(
  `${baseVueRouterPath}/customer/:customer/task`,
  routes,
  { prefix: "task." },
);

const mapCustomerEmailRoutes = (routes) => mapRoutesWithBasePath(
  `${baseVueRouterPath}/customer/:customerId/email`,
  routes,
  { prefix: "customer.email." },
);

const mapCustomerAnalysisRoutes = (routes) => mapRoutesWithBasePath(
  `${baseVueRouterPath}/customer/:customerId/analysis`,
  routes,
  { prefix: "customer.analysis." },
);

export {
  mapRoutesWithBasePath,
  mapInsuranceRoutes,
  mapTaskRoutes,
  mapDashboardRoutes,
  mapAutomationsRoutes,
  mapCustomerEmailRoutes,
  mapCustomerAnalysisRoutes,
};
